<script>
    import ConnectDB from "../settings/ConnectDB.svelte";

    export let overlayActive = true;
    
</script>

<div>
    {#if overlayActive}
        <div class="baskShadow">
            <div class="backgroudSvgWrap">
                <div>
                    <div style="clip-path: polygon(0 54%, 0 25%, 46% 92%, 100% 74%, 100% 81%, 85% 100%, 32% 100%, 0 72%); background: var(--prim_L2)"></div>
                </div>
                <div>
                    <div style="clip-path: polygon(76% 33%, 100% 8%, 99% 21%, 100% 33%, 73% 46%, 0 30%, 0 14%); background: var(--prim_L2)"></div>
                </div>
            </div>
            <div class="contentLine">
               
            </div>
            <div class="content">
                <ConnectDB></ConnectDB>
            </div>
        </div>
    {/if}
</div>
<style>
    .baskShadow {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        /* background: #000000f0;
        z-index: 100; */
        display: grid;
        grid-template-rows: 1fr auto 1fr;
        grid-template-columns: 1fr auto 1fr;
    }
    .backgroudSvgWrap {
        grid-column: 1 / span 3;
        grid-row: 1 / span 3;
    }
    .backgroudSvgWrap > div {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        /* filter: drop-shadow(0 -1px 0 var(--prim_D2)); */
        filter: drop-shadow(0 0.12rem 0.17rem #333);
    }
    .backgroudSvgWrap > div > div {
        height: 100%;
        width: 100%;
    }
    .contentLine {
        background: #ffffffcc;
        grid-column: 1 / span 3;
        grid-row: 2;
        z-index: 5;
    }
    .content {
        border: solid var(--back_D12) 1px;
        background: white;
        grid-column: 2;
        grid-row: 2;
        padding: 2rem;
        margin: 2rem;
        z-index: 6;
    }
</style>